(function () {
  'use strict';

  var gtmLoaded = false;
  var reloadScheduled = false;
  var GTM_ID = 'GTM-MXZPZXM';
  var WITHDRAWAL_KEY = 'melindas-consent-withdrawal-v1';
  var scriptStartedAt = Date.now();
  var analyticsCookieNames = /^(?:_ga(?:_.+)?|_gid|_gat(?:_.+)?)$/;
  var marketingCookieNames = /^(?:_gac_.+|_gcl_.+|_fbp|_fbc|_tt_enable_cookie|_ttp|ttcsid(?:_.+)?|__kla_id|_ama)$/;
  var consentChannel;
  var confirmationPending = false;
  var confirmationSequence = 0;
  var peerReloadScheduled = false;
  var peerSyncPending = false;
  var nativeWithdrawalPending = false;
  var tagsDenied = false;
  var handledMarkerId = null;
  var ownMarkerRaw = null;
  var initialReconcile = true;
  var guardedPrivacy;
  var guardedSetTrackingConsent;

  function parseMarker(raw) {
    if (!raw || typeof raw !== 'string') return null;
    try {
      var marker = JSON.parse(raw);
      return marker && marker.v === 1 && marker.type === 'withdrawn' &&
        typeof marker.id === 'string' && /^[a-z0-9:.]+$/.test(marker.id) &&
        typeof marker.at === 'number' && isFinite(marker.at) &&
        marker.choice && typeof marker.choice.analytics === 'boolean' &&
        typeof marker.choice.marketing === 'boolean' &&
        (marker.choice.preferences === undefined || typeof marker.choice.preferences === 'boolean') &&
        (marker.choice.sale_of_data === undefined || typeof marker.choice.sale_of_data === 'boolean')
        ? marker : null;
    } catch (_) { return null; }
  }

  function ownMarkerSupersedes(raw) {
    var own = parseMarker(ownMarkerRaw);
    var stored = parseMarker(raw);
    return !!own && (!stored || raw === ownMarkerRaw || stored.at < own.at);
  }

  function readMarkerRaw() {
    try { return window.localStorage.getItem(WITHDRAWAL_KEY); }
    catch (_) { return null; }
  }

  function clearMarker() {
    try { window.localStorage.removeItem(WITHDRAWAL_KEY); } catch (_) {}
    handledMarkerId = null;
  }

  function choiceFromConsent(consent) {
    var choice = {
      analytics: !!consent && consent.analytics === 'yes',
      marketing: !!consent && consent.marketing === 'yes'
    };
    if (consent && (consent.preferences === 'yes' || consent.preferences === 'no')) {
      choice.preferences = consent.preferences === 'yes';
    }
    if (consent && (consent.sale_of_data === 'yes' || consent.sale_of_data === 'no')) {
      choice.sale_of_data = consent.sale_of_data === 'yes';
    }
    return choice;
  }

  function matchesChoice(consent, choice) {
    return !!consent && Object.keys(choice).every(function (key) {
      return consent[key] === (choice[key] ? 'yes' : 'no');
    });
  }

  function stricterChoice(left, right) {
    var choice = {
      analytics: left.analytics === true && right.analytics === true,
      marketing: left.marketing === true && right.marketing === true
    };
    ['preferences', 'sale_of_data'].forEach(function (key) {
      if (left[key] === false || right[key] === false) choice[key] = false;
      else if (left[key] === true && right[key] === true) choice[key] = true;
    });
    return choice;
  }

  function publishWithdrawal(forceNew, choice) {
    var raw = readMarkerRaw();
    if (forceNew || !parseMarker(raw)) {
      var marker = { v: 1, type: 'withdrawn', at: Date.now(),
        id: Date.now().toString(36) + ':' + Math.random().toString(36).slice(2),
        choice: choice || choiceFromConsent(currentConsent()) };
      raw = JSON.stringify(marker);
      ownMarkerRaw = raw;
    }
    var stored = false;
    try { window.localStorage.setItem(WITHDRAWAL_KEY, raw); stored = true; } catch (_) {}
    if (consentChannel) {
      try { consentChannel.postMessage({ type: 'melindas-consent-withdrawn', v: 1, marker: raw, stored: stored }); } catch (_) {}
    }
    return raw;
  }

  function hasLoadedTags() {
    return gtmLoaded || !!window.ttq || typeof window.fbq === 'function' || !!window.google_tag_manager;
  }

  function currentConsent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.currentVisitorConsent === 'function'
        ? privacy.currentVisitorConsent()
        : null;
    } catch (_) {
      return null;
    }
  }

  function allowsCombinedTags(consent) {
    return !!consent && consent.analytics === 'yes' && consent.marketing === 'yes' &&
      consent.sale_of_data !== 'no';
  }

  function deniesMarketing(choice) {
    return !choice || choice.marketing !== true || choice.sale_of_data === false;
  }

  function sharedCleanupChoice() {
    var marker = parseMarker(readMarkerRaw());
    if (!marker) return { analytics: false, marketing: false };
    var consent = currentConsent();
    if (!consent) return marker.choice;
    var current = choiceFromConsent(consent);
    return {
      analytics: marker.choice.analytics === true && current.analytics,
      marketing: marker.choice.marketing === true && current.marketing,
      sale_of_data: marker.choice.sale_of_data === false || current.sale_of_data === false
        ? false : undefined
    };
  }

  function clearVendorCookies(choice) {
    var hostname = window.location.hostname.toLowerCase();
    var domains = ['', hostname];
    if (hostname === 'melindes.com' || hostname.endsWith('.melindes.com')) {
      domains.push('melindes.com', '.melindes.com');
    }

    document.cookie.split(';').forEach(function (part) {
      var name = part.trim().split('=')[0];
      if (!(((!choice || choice.analytics !== true) && analyticsCookieNames.test(name)) ||
          (deniesMarketing(choice) && marketingCookieNames.test(name)))) return;
      domains.forEach(function (domain) {
        document.cookie = name + '=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/' +
          (domain ? '; Domain=' + domain : '');
      });
    });
  }

  function denyLoadedTags(choice) {
    if (!hasLoadedTags()) return;
    var denyAds = deniesMarketing(choice);
    if (gtmLoaded || window.google_tag_manager || Array.isArray(window.dataLayer)) {
      var update = {};
      if (!choice || choice.analytics !== true) {
        window['ga-disable-G-XJB03R939G'] = true;
        update.analytics_storage = 'denied';
      }
      if (denyAds) {
        update.ad_storage = 'denied';
        update.ad_user_data = 'denied';
        update.ad_personalization = 'denied';
      }
      if (Object.keys(update).length) {
        var gtag = function () { window.dataLayer.push(arguments); };
        tagsDenied = true;
        window.dataLayer = window.dataLayer || [];
        gtag('consent', 'update', update);
      }
    }
    if (denyAds && typeof window.fbq === 'function') {
      tagsDenied = true;
      try { window.fbq('consent', 'revoke'); } catch (_) { /* reload below is authoritative */ }
    }
  }

  function revokeTikTok(choice) {
    if (!deniesMarketing(choice)) return;
    var ttq = window.ttq;
    if (!ttq) return;
    try {
      // The live GTM Custom HTML tag omits TikTok's consent methods from its base snippet.
      if (typeof ttq.setAndDefer === 'function') {
        ttq.setAndDefer(ttq, 'revokeConsent');
      }
      if (typeof ttq.revokeConsent === 'function') {
        tagsDenied = true;
        ttq.revokeConsent();
      }
    } catch (_) { /* the saved choice still triggers the reload below */ }
  }

  function guardConsentWrites() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function' ||
        (privacy === guardedPrivacy && privacy.setTrackingConsent === guardedSetTrackingConsent)) return;
    var original = privacy.setTrackingConsent;
    var guarded = function (choice) {
      if (!peerSyncPending && choice && typeof choice === 'object') {
        var before = currentConsent();
        var next = choiceFromConsent(before);
        ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (key) {
          if (typeof choice[key] === 'boolean') next[key] = choice[key];
        });
        if (choice.analytics === true && choice.marketing === true && next.sale_of_data !== false) {
          nativeWithdrawalPending = false;
        } else if (!nativeWithdrawalPending && before &&
            ((allowsCombinedTags(before) &&
              (!next.analytics || !next.marketing || next.sale_of_data === false)) ||
             (before.analytics === 'yes' && !next.analytics) ||
             (before.marketing === 'yes' && !next.marketing) ||
             (before.sale_of_data !== 'no' && next.sale_of_data === false))) {
          nativeWithdrawalPending = true;
          publishWithdrawal(true, next);
          revokeTikTok(next);
          denyLoadedTags(next);
        }
      }
      return original.apply(this, arguments);
    };
    try {
      privacy.setTrackingConsent = guarded;
      if (privacy.setTrackingConsent === guarded) {
        guardedPrivacy = privacy;
        guardedSetTrackingConsent = guarded;
      }
    } catch (_) { /* the saved-choice event remains a fail-closed fallback */ }
  }

  function reloadOnceConsentSettles() {
    if (reloadScheduled) return;
    reloadScheduled = true;
    var checks = 0;
    function check() {
      var consent = currentConsent();
      if (consent && !allowsCombinedTags(consent)) {
        window.location.reload();
      } else if (++checks < 20) {
        window.setTimeout(check, 100);
      } else {
        // A newer affirmative choice may have arrived; refresh disabled tags anyway.
        window.location.reload();
      }
    }
    window.setTimeout(check, 100);
  }

  function loadGtm() {
    if (gtmLoaded) return;
    gtmLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
    document.head.appendChild(script);
  }

  function closeOldTab(raw, fallback) {
    var marker = parseMarker(raw);
    if (!marker && !fallback) return;
    if (marker && scriptStartedAt > marker.at) return; // This page started under the closed gate.
    // A native Accept must not apply this page's own earlier withdrawal as a peer write.
    // Compare the exact value, and let this page's marker win over an older stored one.
    if (marker && ownMarkerSupersedes(raw)) return;
    var choice = marker ? marker.choice : { analytics: false, marketing: false };
    clearVendorCookies(choice);
    denyLoadedTags(choice);
    if (peerReloadScheduled || (marker && !hasLoadedTags() &&
        matchesChoice(currentConsent(), marker.choice))) return;
    if (marker && handledMarkerId === marker.id) return;
    if (marker) handledMarkerId = marker.id;
    peerReloadScheduled = true;
    var ttq = window.ttq;
    if (ttq && deniesMarketing(choice)) {
      ['track', 'page', 'identify'].forEach(function (method) {
        try { if (typeof ttq[method] === 'function') ttq[method] = function () {}; } catch (_) {}
      });
    }
    // Shopify's privacy API is cached separately in each open tab. A plain
    // reload here can rehydrate an old Yes and restart Shopify-managed pixels.
    // Apply the visitor's same-origin choice in this tab before navigating.
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var attempts = 0;
    var pollScheduled = false;
    function schedulePoll(delay) {
      if (pollScheduled) return;
      pollScheduled = true;
      window.setTimeout(function () {
        pollScheduled = false;
        waitForLocalChoice();
      }, delay);
    }
    function waitForLocalChoice() {
      if (!peerReloadScheduled) return;
      if (marker && !fallback && readMarkerRaw() !== raw) {
        peerSyncPending = false;
        peerReloadScheduled = false;
        handledMarkerId = null;
        return;
      }
      var consent = currentConsent();
      if (consent && (marker ? matchesChoice(consent, marker.choice) : !allowsCombinedTags(consent))) {
        peerReloadScheduled = false;
        window.location.reload();
      } else if (++attempts < 30) {
        schedulePoll(100);
      } else {
        // Stay fail-closed in this page; a later focus can retry the sync.
        peerSyncPending = false;
        peerReloadScheduled = false;
        handledMarkerId = null;
      }
    }
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      peerSyncPending = true;
      try {
        privacy.setTrackingConsent(marker ? marker.choice : { analytics: false, marketing: false }, function () {
          schedulePoll(0);
        });
      } catch (_) { peerSyncPending = false; }
    }
    schedulePoll(100);
  }

  function sharedWithdrawal(allowFreshRecovery) {
    var raw = readMarkerRaw();
    var marker = parseMarker(raw);
    if (!marker) return false;
    // The saving tab must finish Shopify's native Save before it navigates.
    if (confirmationPending || (nativeWithdrawalPending && ownMarkerSupersedes(raw))) return true;
    var consent = currentConsent();
    // Only a newly executed page can recognize a later choice from another origin.
    if (scriptStartedAt - marker.at >= 60000 &&
        allowsCombinedTags(consent)) {
      clearMarker();
      return false;
    }
    if (allowFreshRecovery && scriptStartedAt - marker.at >= 60000 && consent &&
        (consent.analytics === 'yes' || consent.analytics === 'no') &&
        (consent.marketing === 'yes' || consent.marketing === 'no') &&
        (consent.analytics !== (marker.choice.analytics ? 'yes' : 'no') ||
         consent.marketing !== (marker.choice.marketing ? 'yes' : 'no'))) {
      // Keep the original close signal for older tabs, but use this fresh page's choice.
      marker.choice = choiceFromConsent(consent);
      try {
        var revisedRaw = JSON.stringify(marker);
        window.localStorage.setItem(WITHDRAWAL_KEY, revisedRaw);
        raw = revisedRaw;
      } catch (_) { /* keep the stored marker and stricter cleanup */ }
    }
    closeOldTab(raw, false);
    return true;
  }

  function reconcile() {
    guardConsentWrites();
    var consent = currentConsent();
    var allowFreshRecovery = initialReconcile;
    if (consent) initialReconcile = false;
    if (sharedWithdrawal(allowFreshRecovery)) {
      clearVendorCookies(sharedCleanupChoice());
      return;
    }
    if (!consent) return; // The API is still loading; GTM remains off.
    if (allowsCombinedTags(consent)) {
      if (!reloadScheduled && !confirmationPending) loadGtm();
      return;
    }
    var choice = choiceFromConsent(consent);
    clearVendorCookies(choice);
    if (gtmLoaded) {
      denyLoadedTags(choice);
      if (!confirmationPending) reloadOnceConsentSettles();
    }
  }

  function onConsentChange() {
    if (peerSyncPending && readMarkerRaw()) return; // The other tab already published this choice.
    // Shopify can publish before all readers see the saved choice. Hold reloads
    // until a bounded confirmation has notified other tabs.
    var sequence = ++confirmationSequence;
    var started = Date.now();
    var last = null;
    var repeats = 0;
    var denied = false;
    confirmationPending = true;
    function check() {
      if (sequence !== confirmationSequence) return;
      var consent = currentConsent();
      var state = consent ? (allowsCombinedTags(consent) ? 'yes' : 'no') : null;
      var raw = readMarkerRaw();
      // Failed storage must not lose the local choice already sent to peers.
      // A valid stored marker at least as new as this page's marker supersedes
      // the pending choice; an older marker must not.
      var pending = nativeWithdrawalPending && ownMarkerSupersedes(raw)
        ? parseMarker(ownMarkerRaw) : null;
      var observedChoice = choiceFromConsent(consent);
      var matchesPending = !pending || matchesChoice(consent, pending.choice);
      // A stale mixed choice is also "no"; confirm the selected categories,
      // not merely the closed combined gate, before publishing or reloading.
      var confirmation = state === 'no'
        ? (matchesPending ? 'no:' + JSON.stringify(observedChoice) : null)
        : state;
      if (confirmation === last) repeats += 1;
      else { last = confirmation; repeats = 1; }
      if (state === 'no' && !denied) {
        denied = true;
        var cleanupChoice = pending ? pending.choice : observedChoice;
        clearVendorCookies(cleanupChoice);
        denyLoadedTags(cleanupChoice);
      }
      var elapsed = Date.now() - started;
      var result = null;
      if (state === 'no' && matchesPending && repeats >= 2) result = 'no';
      else if (state === 'yes' && repeats >= 2 && elapsed >= 1200 && !nativeWithdrawalPending) result = 'yes';
      else if (elapsed >= 3000) result = 'no'; // Unknown or flapping: fail closed.
      if (!result) { window.setTimeout(check, 100); return; }
      confirmationPending = false;
      if (result === 'no') {
        var choice = pending
          ? (matchesPending ? observedChoice : stricterChoice(pending.choice, observedChoice))
          : (consent && !allowsCombinedTags(consent)
            ? observedChoice : { analytics: false, marketing: false });
        var existing = parseMarker(readMarkerRaw());
        var changed = !existing || Object.keys(choice).some(function (key) {
          return existing.choice[key] !== choice[key];
        });
        publishWithdrawal(changed, choice);
        nativeWithdrawalPending = false;
        clearVendorCookies(choice);
        denyLoadedTags(choice);
        if (hasLoadedTags()) window.location.reload();
      } else {
        clearMarker();
        nativeWithdrawalPending = false;
        if ((denied || tagsDenied) && hasLoadedTags()) window.location.reload();
        else reconcile();
      }
    }
    window.setTimeout(check, 0);
  }

  function fallbackToPolicy(button) {
    var url = button.getAttribute('data-privacy-policy-url');
    if (url) window.location.assign(url);
  }

  function restoreFocusWhenPreferencesClose(button, scrollX, scrollY) {
    if (!document.getElementById) return;
    var wasOpen = false;
    var checks = 0;
    var observer;
    var finished = false;
    function focusTrigger() {
      if (!button.isConnected) return;
      window.scrollTo(scrollX, scrollY);
      button.focus({ preventScroll: true });
      var bounds = button.getBoundingClientRect();
      if (bounds.top < 8) window.scrollBy(0, bounds.top - 8);
      else if (bounds.bottom > window.innerHeight - 8) {
        window.scrollBy(0, bounds.bottom - (window.innerHeight - 8));
      }
    }
    function check() {
      if (finished) return;
      var prefs = document.getElementById('shopify-pc__prefs');
      if (prefs && prefs.getClientRects().length > 0) {
        wasOpen = true;
      } else if (wasOpen) {
        finished = true;
        if (observer) observer.disconnect();
        focusTrigger();
        // Shopify can move focus to its hidden banner after closing the dialog.
        window.setTimeout(function () {
          var active = document.activeElement;
          var prefs = document.getElementById('shopify-pc__prefs');
          if (!active || active === document.body ||
              !active.isConnected || active.id === 'MainContent' ||
              active.id === 'shopify-pc__banner' ||
              (prefs && prefs.contains(active))) focusTrigger();
        }, 400);
        return;
      }
      if (!observer && ++checks < 3000 && button.isConnected) window.setTimeout(check, 100);
    }
    if (typeof window.MutationObserver === 'function' && document.body) {
      observer = new window.MutationObserver(check);
      observer.observe(document.body, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
      window.setTimeout(function () { finished = true; observer.disconnect(); }, 300000);
    }
    check();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-melindas-preferences]');
    if (!button) return;
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') {
      fallbackToPolicy(button);
      return;
    }
    try {
      var scrollX = window.scrollX;
      var scrollY = window.scrollY;
      // Shopify's current banner can throw while removing its focused old dialog.
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
      var opening = banner.showPreferences();
      restoreFocusWhenPreferencesClose(button, scrollX, scrollY);
      if (opening && typeof opening.catch === 'function') {
        opening.catch(function () { fallbackToPolicy(button); });
      }
    } catch (_) {
      fallbackToPolicy(button);
    }
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var button = event.target.closest(
      '#shopify-pc__prefs__header-save, #shopify-pc__prefs__header-decline, ' +
      '#shopify-pc__prefs__header-accept, #shopify-pc__banner__btn-accept, ' +
      '#shopify-pc__banner__btn-decline'
    );
    if (!button) return;
    if (button.id === 'shopify-pc__prefs__header-accept' ||
        button.id === 'shopify-pc__banner__btn-accept') {
      nativeWithdrawalPending = false;
      return;
    }
    if (button.id === 'shopify-pc__prefs__header-decline' ||
        button.id === 'shopify-pc__banner__btn-decline') {
      nativeWithdrawalPending = true;
      var declinedChoice = { analytics: false, marketing: false, preferences: false };
      publishWithdrawal(true, declinedChoice);
      revokeTikTok(declinedChoice);
      denyLoadedTags(declinedChoice);
      return;
    }
    var analytics = document.getElementById('shopify-pc__prefs__analytics-input');
    var marketing = document.getElementById('shopify-pc__prefs__marketing-input');
    var preferences = document.getElementById('shopify-pc__prefs__preferences-input');
    // TikTok's revoke command itself sends a request, so issue it before Shopify
    // saves a choice that closes the gate; never repeat it after consent is no.
    if (!analytics || !marketing) {
      // Shopify may change its dialog markup. Do not invent a No choice when
      // the controls cannot be read; the saved API event decides the outcome.
      nativeWithdrawalPending = false;
      return;
    }
    var choice = choiceFromConsent(currentConsent());
    choice.analytics = analytics.checked;
    choice.marketing = marketing.checked;
    if (preferences) choice.preferences = preferences.checked;
    if (!choice.analytics || !choice.marketing || choice.sale_of_data === false) {
      nativeWithdrawalPending = true;
      publishWithdrawal(true, choice);
      revokeTikTok(choice);
      denyLoadedTags(choice);
    } else {
      nativeWithdrawalPending = false;
    }
  }, true);

  document.addEventListener('visitorConsentCollected', onConsentChange);
  window.addEventListener('storage', function (event) {
    if (!event || event.key !== WITHDRAWAL_KEY || !event.newValue) return;
    if (readMarkerRaw() !== event.newValue) return; // A later Accept removed it.
    closeOldTab(event.newValue, false);
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reconcile();
  });
  window.addEventListener('focus', reconcile);
  window.addEventListener('pageshow', function (event) {
    if (sharedWithdrawal()) {
      clearVendorCookies(sharedCleanupChoice());
      return;
    }
    var consent = currentConsent();
    if (event.persisted && gtmLoaded && !allowsCombinedTags(consent)) {
      var choice = choiceFromConsent(consent);
      clearVendorCookies(choice);
      denyLoadedTags(choice);
      window.location.reload();
      return;
    }
    // An unresolved API leaves tracking off; its callback will make the decision.
    if (consent) reconcile();
  });

  if (typeof window.BroadcastChannel === 'function') {
    try {
      consentChannel = new window.BroadcastChannel('melindas-consent');
      consentChannel.onmessage = function (event) {
        var data = event && event.data;
        if (!data || data.type !== 'melindas-consent-withdrawn' || data.v !== 1 ||
            typeof data.marker !== 'string' || typeof data.stored !== 'boolean' ||
            !parseMarker(data.marker)) return;
        if (data.stored && readMarkerRaw() !== data.marker) return;
        if (!data.stored && Date.now() - parseMarker(data.marker).at > 10000) return;
        closeOldTab(data.marker, !data.stored);
      };
    } catch (_) { /* visibility and page-show checks still apply */ }
  }

  try {
    guardConsentWrites();
    if (currentConsent()) {
      reconcile();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.2' }],
        function (error) { if (!error) reconcile(); else clearVendorCookies({ analytics: false, marketing: false }); }
      );
    } else {
      reconcile();
    }
  } catch (_) {
    clearVendorCookies({ analytics: false, marketing: false });
  }
})();
